import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {SkillGroupBaseModel, SkillGroupFilter} from '../../models/edu-admin/skillGroupBase.model';
import {QuestionModel} from '../../models/questions/question.model';
import {generateQuestionList} from '../../models/questions/question-generator';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringExtensionModel} from '../../models/extensions/string-extension.model';
import {EVOQuestionFilter} from './admin-question.service';
import {SkillGroupExtendedModel} from '../../models/edu-admin/skillGroupExtended.model';

@Injectable({
  providedIn: 'root'
})

export class AdminSkillGroupService {

  constructor(private authSv: AuthService) {
  }

  fetchSkillGroups(filter: SkillGroupFilter): Observable<SkillGroupExtendedModel[]> {

    let url = '/skillGroups';

    if (filter) {
      url += StringExtensionModel.queryString(filter);
    }

    return this.authSv.get(url).pipe(map((response) => {

      return SkillGroupExtendedModel.generateModels(response.data);

    }));
  }

  fetchSkillGroupById(skillGroupId: string): Observable<SkillGroupExtendedModel> {
    return this.authSv.get('/skillGroups/' + skillGroupId).pipe(map((response) => {
      return SkillGroupExtendedModel.generate(response.data);
    }));
  }


  createSkillGroup(skillGroup: SkillGroupExtendedModel): Observable<SkillGroupExtendedModel> {
    return this.authSv.post('/skillGroups', skillGroup).pipe(map((response) => {
      return SkillGroupExtendedModel.generate(response.data.skillGroup);
    }));
  }

  fetchOtherQuestions(skillGroupId: string, filter: EVOQuestionFilter = null): Observable<QuestionModel[]> {

    let url = '/skillGroups/' + skillGroupId + '/otherQuestions';
    if (filter) {
      url += StringExtensionModel.queryString(filter);
    }

    return this.authSv.get(url).pipe(map((response) => {
      return generateQuestionList(response.data);
    }));
  }

  updateSkillGroup(skillGroup: SkillGroupBaseModel, populateQuestions = false): Observable<SkillGroupExtendedModel> {

    let url = '/skillGroups/' + skillGroup._id;
    if (populateQuestions) {
      url += '?populateQuestions=1';
    }

    return this.authSv.patch(url, skillGroup).pipe(map((response) => {
      return SkillGroupExtendedModel.generate(response.data);
    }));
  }

  deleteSkillGroup(skillGroupId: string, password: string): Observable<SkillGroupExtendedModel> {
    return this.authSv.post('/skillGroups/' + skillGroupId + '/delete', { password }).pipe(map((response) => {
      return SkillGroupExtendedModel.generate(response.data);
    }));
  }

  fetchSkillGroupsNotInList(list: string[]): Observable<SkillGroupExtendedModel[]> {
    return this.authSv.get('/skillGroups').pipe(map(skillGroupsReceived => {
      const skillGroups: SkillGroupExtendedModel[] = SkillGroupExtendedModel.generateModels(skillGroupsReceived.data);
      return skillGroups.filter(item => !list.includes(item._id));
    }));
  }
  
}
